export { default as component } from "../../../../src/routes/[prefix]/(feature)/staff-select/+page.svelte";